const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    menus: state => state.menu.menus, // 菜单权限信息

}
export default getters
